import Create from "./Create";
import Edit from "./Edit";
import { ExecutiveProjectIcon } from "../icons";
import List from "./List";

const config = {
  icon: ExecutiveProjectIcon,
  options: {
    group: "dashboard",
    accessible: (identity, permissions) => {
      if (permissions(["admin", "tro", "reader", "manager"])) {
        return true;
      }
      if (!permissions(["researcher"])) {
        return false;
      }
      return (
        identity?.permissions &&
        identity?.permissions.indexOf("executive-projects") !== -1
      );
    },
  },
  list: List,
  create: Create,
  edit: Edit,
};

export default config;
